import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { NwButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import {
    ActionItem,
    ActionItemBody,
    ActionItemDescription,
    ActionItemFooter,
    ActionItemIcon,
    ActionItemTitle,
} from './ContactDetailsActions-ui';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ArchiveActionItem = ({ archived, contactType, onArchive, onUnarchive }) => {
    if (archived) {
        return (
            <ActionItem>
                <ActionItemIcon>
                    <span className="stacked-icons fa-layers fa-fw fa-lg">
                        <FontAwesomeIcon className="base-icon" icon={byPrefixAndName.fasl['address-book']} />
                        <FontAwesomeIcon className="stacked-icon" icon={byPrefixAndName.fasds['circle-arrow-up']} />
                    </span>
                </ActionItemIcon>
                <ActionItemBody>
                    <ActionItemTitle>Remove from Archive</ActionItemTitle>
                    <ActionItemDescription>{`Set this model active in the booking again`}</ActionItemDescription>
                    <ActionItemFooter>
                        <NwButton primary label={'unarchive'} onClick={onUnarchive} />
                    </ActionItemFooter>
                </ActionItemBody>
            </ActionItem>
        );
    }

    return (
        <ActionItem>
            <ActionItemIcon>
                <NwIcon size="3x" icon={byPrefixAndName.fasl['box-archive']} />
            </ActionItemIcon>
            <ActionItemBody>
                <ActionItemTitle>{`Archive ${contactType}`}</ActionItemTitle>
                <ActionItemDescription>
                    {`You will be able to unarchive this ${contactType} in the management section`}
                </ActionItemDescription>
                <ActionItemFooter>
                    <NwButton danger label={'archive'} onClick={onArchive} />
                </ActionItemFooter>
            </ActionItemBody>
        </ActionItem>
    );
};

export default ArchiveActionItem;
